<template lang="pug">
div
	div(v-if='category=="line-item"')
		section(style='padding-right:1rem')
			b(v-if=`task.job_code`, style="margin-right:1rem") {{task.job_code}}
			span {{task.job_name}}
			br
			span(v-if='task').ellipse
				span(v-if='task.phaseCode').phaseCode.margin-right Phase: {{task.phaseCode}}
				span(v-if='task.phaseCode && task.costCode').margin-right |
				span(v-if='task.costCode').margin-right.costCode Cost: {{task.costCode}}
				span(v-if='(task.phaseCode || task.costCode) && task.changeOrder').margin-right |
				span(v-if='task.changeOrder').margin-right ({{task.changeOrder}})
				span(v-if='task.phaseCode || task.costCode').margin-right -
				span {{task.name}}
	div(v-if='category=="equipment"')
			b(v-if=`task.code`).margin-right {{task.code}}
			span {{task.name}}
	div(v-if='category=="workorder"')
			b(v-if=`task.code`).margin-right {{task.code}}
			span {{task.name}}
</template>

<script>
export default {
  name: "TaskLabel",

  props: ["task", "category"],
  mounted: function() {}
};
</script>

<style scoped lang="less">
</style>
